import Vue from 'vue'
import injector from 'vue-inject'
import * as R from 'ramda'
import * as types from './mutation-types'

export default {
  [types.SET_AGENT_ID] (state, agentId) { state.agentId = agentId },
  [types.SET_PAYMENT_METHOD] (state, paymentMethod) {
    if ((
      paymentMethod !== injector.get('paymentMethodType').easyCard &&
        state.receiptCarrier === injector.get('receiptCarrierType').easyCard) ||
      paymentMethod === injector.get('paymentMethodType').cash
    ) {
      state.receiptCarrier = injector.get('receiptCarrierType').paper
    }

    state.paymentMethod = paymentMethod
  },
  [types.SET_PAYMENT_METHOD_DISCOUNT] (state, paymentMethodDiscount) { // 加入選擇付款方式的優惠折扣
    state.paymentMethodDiscount = paymentMethodDiscount
  },
  [types.SET_RECEIPT_CARRIER] (state, receiptCarrier) { state.receiptCarrier = receiptCarrier },
  [types.SET_RECEIPT_CARRIER_ID] (state, id) { state.receiptCarrierId = id },
  [types.SET_TAX_ID] (state, v) { state.taxId = v },
  [types.SET_INVOICE_TITLE] (state, v) { state.invoiceTitle = v },
  [types.SET_DINING_PREFERENCE] (state, diningPreference) { state.diningPreference = diningPreference },
  [types.SET_TABLE_NUMBERS] (state, tableNumbers) {
    if (!R.equals(tableNumbers, state.tableNumbers)) {
      Vue.set(state, 'tableNumbers', tableNumbers)
    }
  },
  [types.SET_TABLE_NUMBER] (state, tableNumber) { state.tableNumber = tableNumber },
  [types.SET_PHONE_NUMBER] (state, phoneNumber) { state.phoneNumber = phoneNumber },
  [types.SET_PICKUP_TIME] (state, pickupTime) { state.pickupTime = pickupTime },
  [types.SET_NICKNAME] (state, nickname) { state.nickname = nickname },
  [types.SET_QR_CODE] (state, publicId) {
    // 如果傳輸的時候，訂單 id 使用一個不會重複的 id，就不需要傳送這麼多東西了...
    state.publicId = publicId
  },
  [types.SET_STORE] (state, store) { Vue.set(state, 'store', store) },
  [types.SET_MENU_URL] (state, url) { state.menuUrl = url },
  [types.SET_MENU_VARIATION] (state, variation) { state.menuVariation = variation },
  [types.SET_ORDER_PARAMS] (state, params) {
    Object.keys(params).forEach(k => {
      if (!R.isNil(params[k])) {
        state[k] = params[k]
      }
    })
  },
  [types.RESET_ORDER_PARAMS] (state) {
    state.nickname = ''
    state.publicId = null
    state.diningPreference = injector.get('diningPreferenceType').forHere
    state.tableNumber = null
    state.pickupTime = null
    state.phoneNumber = null
    state.paymentMethod = null
    state.paymentMethodDiscount = 0
    state.receiptCarrier = injector.get('receiptCarrierType').paper
    state.receiptCarrierId = ''
    state.taxId = ''
    state.invoiceTitle = ''
  },
  [types.SET_BUSINESS_HOURS] (state, businessHours) {
    state.businessHours = businessHours
  }
}
